// import React, { useState } from "react";
// import { Card, Row, Col, Typography, Tooltip, Spin } from "antd";
// import DonutChart from "../../../components/DonutChart";
// import { DollarCircleOutlined, QuestionCircleOutlined, } from "@ant-design/icons";
// import moment from "moment";
// import _commonService from "../../../modules/commonService";
// import StatusTag from "../../../components/StatusTag";

// const { Title, Text } = Typography;

// const LoanDetailsHeaderForAdministrator = ({ applicantDetails }) => {
//   const [loading] = useState(false);

//   const PreApprovedWatermark = () => {
//     const watermarkColor = "rgba(66, 115, 111, 0.2)";

//     return (
//       <svg
//         width="150"
//         height="150"
//         viewBox="0 0 300 300"
//         style={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%) rotate(-15deg)",
//           opacity: 1,
//           pointerEvents: "none",
//           zIndex: 0,
//         }}
//       >
//         {/* Outer circle */}
//         <circle
//           cx="150"
//           cy="150"
//           r="120"
//           fill="none"
//           stroke={watermarkColor}
//           strokeWidth="10"
//           strokeDasharray="6,6"
//         />

//         {/* Inner circle */}
//         <circle
//           cx="150"
//           cy="150"
//           r="95"
//           fill="none"
//           stroke={watermarkColor}
//           strokeWidth="6"
//         />

//         {/* Stars */}
//         {[...Array(6)].map((_, i) => {
//           const angle = (i * 360) / 6;
//           const x = 150 + 80 * Math.cos((angle * Math.PI) / 180);
//           const y = 150 + 80 * Math.sin((angle * Math.PI) / 180);
//           return (
//             <text
//               key={i}
//               x={x}
//               y={y}
//               textAnchor="middle"
//               dominantBaseline="middle"
//               fontSize="16"
//               fill={watermarkColor}
//             >
//               ★
//             </text>
//           );
//         })}

//         {/* Ribbon */}
//         <rect
//           x="25"
//           y="125"
//           width="250"
//           height="50"
//           fill={watermarkColor} // optional, can keep original red if you want
//           rx="6"
//         />

//         {/* Ribbon text */}
//         <text
//           x="150"
//           y="158"
//           textAnchor="middle"
//           fontSize="28"
//           fontWeight="700"
//           fill={"#555"} // optional, makes text match watermark color
//           letterSpacing="2"
//         >
//           PRE-QUALIFY
//         </text>
//       </svg>
//     );
//   };


//   return (
//     <Spin spinning={loading}>
//       <Card
//         bordered={false}
//         // style={{
//         //   margin: "20px auto",
//         //   boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//         // }}
//         className="cardViewMain application-details-header-card"
//       >
//         <div>
//           {/* style={{ padding: "16px 24px 16px 24px" }}   */}
//           <Row justify="" gutter={[16, 16]}>
//             <Col
//               className="gutter-row"
//               xs={{ span: 12 }}
//               sm={{ span: 12 }}
//               md={{ span: 12 }}
//               lg={{ span: 12 }}
//               xl={{ span: 4 }}
//               xxl={{ span: 4 }}
//             >
//               <div>
//                 <div>
//                   <StatusTag statusId={applicantDetails.Application_Status_Id} />
//                   <div style={{ marginTop: 8 }}>
//                     <Text strong><DollarCircleOutlined /> {applicantDetails && applicantDetails.ApplicationId}</Text>
//                   </div>
//                   <div>
//                     <Text type="secondary">Date: {applicantDetails && moment(applicantDetails.createdDate).format("MM/DD/YYYY")}</Text>
//                   </div>
//                 </div>

//                 <div className="mt20">
//                   <Col>
//                     <Title level={4} style={{ margin: 0 }}>
//                       $ {applicantDetails && _commonService.formatNumberWithCommas(applicantDetails.Cons_ApproximateLoanSize)}
//                     </Title>
//                     <Text type="secondary">Loan Inquiry</Text>
//                   </Col>
//                 </div>
//               </div>
//             </Col>


//             <Col
//               className="gutter-row "
//               xs={{ span: 24 }}
//               sm={{ span: 24 }}
//               md={{ span: 24 }}
//               lg={{ span: 12 }}
//               xl={{ span: 14 }}
//               xxl={{ span: 14 }}
//             >

//               <Row gutter={[16, 16]} className="mb20">
//                 <Col xs={24} sm={8}>
//                   <Text type="secondary">First Name:</Text><br />
//                   <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_FirstName}</Text>
//                 </Col>
//                 <Col xs={24} sm={8}>
//                   <Text type="secondary">Middle Initial:</Text><br />
//                   <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_MiddleInitial || "N/A"}</Text>
//                 </Col>
//                 <Col xs={24} sm={8}>
//                   <Text type="secondary">Last Name:</Text><br />
//                   <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_LastName}</Text>
//                 </Col>

//                 <Col xs={24} sm={8}>
//                   <Text type="secondary">Applicant Type:</Text><br />
//                   <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_Application_Type}</Text>
//                 </Col>
//                 <Col xs={24} sm={8}>
//                   <Text type="secondary">Date Of Birth:</Text><br />
//                   <Text className="b-bottm">{applicantDetails && moment(applicantDetails.App_Det_DateOfBirth).format("MM/DD/YYYY")}</Text>
//                 </Col>
//                 <Col xs={24} sm={8}>
//                   <Text type="secondary">Phone:</Text><br />
//                   <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_ContactNumber ? _commonService.formatUSPhoneNumber(applicantDetails.App_Det_ContactNumber) : "N/A"}</Text>
//                 </Col>
//                 <Col xs={24} sm={8}>
//                   <Text type="secondary">City:</Text><br />
//                   <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_City || "N/A"}</Text>
//                 </Col>
//                 <Col xs={24} sm={8}>
//                   <Text type="secondary">State:</Text><br />
//                   <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_State || "N/A"}</Text>
//                 </Col>
//                 <Col xs={24} sm={8}>
//                   <Text type="secondary">Zip Code:</Text><br />
//                   <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_ZipCode || "N/A"}</Text>
//                 </Col>
//                 <Col xs={24} sm={16}>
//                   <Text type="secondary">Email:</Text><br />
//                   <Text className="b-bottm">{applicantDetails && applicantDetails.Email}</Text>
//                 </Col>
//               </Row>
//             </Col>

//             <Col xs={24}
//               sm={24}
//               md={24}
//               lg={6}
//               xl={6}>
//               <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
//                 <Text strong style={{ fontSize: 16, marginRight: 8, marginLeft: 30 }}>Limit Usage</Text>
//                 <Tooltip title="What is Limit Usage?">
//                   <QuestionCircleOutlined style={{ fontSize: 16, cursor: "pointer" }} />
//                 </Tooltip>
//               </div>

//               <div style={{ display: "flex", justifyContent: "flex-start", marginLeft: -38 }}>
//                 <DonutChart data={[
//                   { type: "Remaining", value: applicantDetails && applicantDetails.sponserModel && Number(applicantDetails.sponserModel.Remaining) || 0 },
//                   { type: "Utilized", value: applicantDetails && applicantDetails.sponserModel && Number(applicantDetails.sponserModel.Utilized) || 0 }
//                 ]}

//                   title="Budget"
//                 />
//               </div>
//             </Col>

//             <Col
//               style={{
//                 paddingLeft: "185%",
//                 right: "25px",
//                 bottom: "80px",
//                 zIndex: 9999
//               }}
//             >
//               {applicantDetails?.IsPreQualify === true && <PreApprovedWatermark />}
//             </Col>

//           </Row>
//         </div>
//       </Card>
//     </Spin>
//   );
// };

// export default LoanDetailsHeaderForAdministrator;

import React, { useState } from "react";
import { Row, Col, Typography, Button, Progress, Tag, Divider } from "antd";
import { DollarCircleOutlined, QuestionCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import _commonService from "../../../modules/commonService";
import StatusTag from "../../../components/StatusTag";
// import StatusTag from "../../../components/StatusTag"; 
// import DonutChart from "../../../components/DonutChart"; 


const { Text } = Typography;

const LoanDetailsHeaderForAdministrator = ({ applicantDetails }) => {
  const [loading] = useState(false);

  // --- Helper Component for Field Data ---
  const DetailItem = ({ label, value }) => (
    <div className="lh-detail-item">
      <span className="lh-label">{label}</span>
      <div className="lh-value b-bottm">
        {value || "N/A"}
      </div>
    </div>
  );



  return (
    <div className="loan-header-container">
      <Row>

        {/* ================= LEFT PANEL ================= */}
        <Col xs={24} lg={18}>
          <div className="lh-main-card mr10 mb10">

            {/* Header Row: ID, Status, Amount */}
            <Row justify="space-between" align="top" >
              <Col>
                <div className="lh-app-header">
                  <span className="lh-app-id">
                    <Text className="lh-app-text">{applicantDetails?.ApplicationId}</Text>
                  </span>

                  <StatusTag statusId={applicantDetails?.Application_Status_Id} />
                </div>
                <div className="lh-date">
                  {applicantDetails?.createdDate
                    ? moment(applicantDetails.createdDate).format("MM/DD/YYYY")
                    : "01/07/2026"}
                </div>
              </Col>
              <Col>
                <div className="lh-amount-label">Loan Inquiry Amount</div>
                <div className="lh-amount-value">
                  ${applicantDetails
                    ? _commonService.formatNumberWithCommas(applicantDetails.Cons_ApproximateLoanSize)
                    : "222,222.00"}
                </div>
              </Col>
            </Row>

            <Divider />

            {/* Section Title */}
            <div className="lh-section-title">Applicant Information</div>

            {/* Data Grid */}
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={12} md={6}>
                <DetailItem label="First Name" value={applicantDetails?.App_Det_FirstName || "N/A"} />
              </Col>
              <Col xs={24} sm={12} md={6}>
                <DetailItem label="Last Name" value={applicantDetails?.App_Det_LastName || "N/A"} />
              </Col>
              <Col xs={24} sm={12} md={6}>
                <DetailItem label="Applicant Type" value={applicantDetails?.App_Det_Application_Type || "N/A"} />
              </Col>
              <Col xs={24} sm={12} md={6}>
                <DetailItem label="Middle Initial" value={applicantDetails?.App_Det_MiddleInitial || "N/A"} />
              </Col>

              <Col xs={24} sm={12} md={6}>
                <DetailItem
                  label="Date of Birth"
                  value={applicantDetails?.App_Det_DateOfBirth ? moment(applicantDetails.App_Det_DateOfBirth).format("MMMM D, YYYY") : "N/A"}
                />
              </Col>
              <Col xs={24} sm={12} md={6}>
                <DetailItem
                  label="Phone"
                  value={applicantDetails?.App_Det_ContactNumber ? _commonService.formatUSPhoneNumber(applicantDetails.App_Det_ContactNumber) : "N/A"}
                />
              </Col>
              <Col xs={24} sm={12} md={6}>
                <DetailItem label="City" value={applicantDetails?.Ident_City || "N/A"} />
              </Col>
              <Col xs={24} sm={12} md={6}>
                <DetailItem label="State" value={applicantDetails?.Ident_State || "N/A"} />
              </Col>

              <Col xs={24} sm={12} md={6}>
                <DetailItem label="Zip Code" value={applicantDetails?.Ident_ZipCode || "N/A"} />
              </Col>
              <Col xs={24} sm={24} md={18}>
                <DetailItem label="Email" value={applicantDetails?.Email || "N/A"} />
              </Col>
            </Row>

          </div>
        </Col>

        {/* ================= RIGHT PANEL ================= */}
        <Col xs={24} lg={6}>
          <div className="lh-right-column">

            {/* Box 1: Limit Usage (Updated for perfect visual match) */}
            <div className="lh-sidebar-box">
              <div className="lh-section-title" >Limit Usage</div>

              {/* Container to center the chart vertically and horizontally */}
              <div className="lh-chart-center-wrapper">
                <Progress
                  type="circle"
                  percent={applicantDetails?.sponserModel ? Number(applicantDetails.sponserModel.Utilized) : 0}

                  /* KEY CHANGE: Thicker stroke to match image */
                  strokeWidth={12}
                  strokeColor="#42736f"

                  /* KEY CHANGE: Darker trail for better contrast */
                  trailColor="#262626"

                  width={140}
                  format={(percent) => (
                    <div className="lh-chart-text">
                      <div className="lh-chart-percent">{percent}%</div>
                      <div className="lh-chart-sub">Utilized</div>
                    </div>
                  )}
                />
              </div>
            </div>

            {/* Box 2: Pre-Qualify */}
            {(applicantDetails?.IsPreQualify === true) && (
              <div className="lh-sidebar-box lh-prequalify-box">
                <div className="lh-prequalify-header">
                  <CheckCircleOutlined /> PRE-QUALIFY
                </div>
                <div className="lh-prequalify-text">
                  This application meets the underwriting criteria for available capital providers.
                </div>
              </div>
            )}

          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LoanDetailsHeaderForAdministrator;